<template>
  <div class="myPageNewsStoryList">
    <MyPageNewsStory v-for="article in articles" :key="article.id" v-bind="article" />
  </div>
</template>

<script>
import MyPageNewsStory from '@/components/mypage/MyPageNewsStory';
import axios from 'axios';

export default {
  name: 'MyPageNewsStoryList',

  data() {
    return {
      articles: [],
    };
  },

  components: {
    MyPageNewsStory,
  },

  methods: {
    async fetchMedia({ href }) {
      const { data } = await axios.get(href);
      if (data.media_type !== 'image') {
        return null;
      }
      if (!data.media_details.sizes.large) {
        return null;
      }
      return {
        url: data.media_details.sizes.large.source_url,
        alt: data.alt_text,
      };
    },
    async fetchArticles() {
      const { data } = await axios.get('https://www.husleie.no/wp-json/wp/v2/posts?categories=1');
      const articles = [data[0], data[1], data[2]].map(article => ({
        id: article.id,
        title: article.title.rendered,
        link: article.link,
        date: article.date,
        excerpt: this.makeExcerpt(article.excerpt.rendered),
        image: null,
      }));

      // Async loading of images
      articles.forEach(
        async (article, index) => (article.image = await this.fetchMedia(data[index]._links['wp:featuredmedia'][0]))
      );

      this.articles = articles;
    },
    /**
     * This is needed because the original WP excerpt contains a lot of shortcodes.
     */
    makeExcerpt(str) {
      // TODO: Use content to get a longer excerpt?
      return str.replace(/\[[a-z][^\]]+?\]/g, '');
    },
  },

  async created() {
    await this.fetchArticles();
  },
};
</script>

<style scoped lang="scss">
.myPageNewsStoryList {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem 0rem;
}
</style>
